<template>
  <div id="app">
    <!-- Banner: nueva versión disponible -->
    <transition name="slide-down">
      <div
        v-if="nuevaVersion"
        class="fixed top-0 left-0 right-0 z-[200] bg-blue-600 text-white px-4 py-3 flex items-center justify-center gap-4 shadow-lg"
      >
        <i class="fa-solid fa-rotate"></i>
        <span class="font-medium text-sm">Hay una nueva versión disponible.</span>
        <button
          @click="actualizarPagina"
          class="bg-white text-blue-600 font-bold text-xs px-4 py-1.5 rounded-full hover:bg-blue-50 transition-colors"
        >
          Actualizar ahora
        </button>
      </div>
    </transition>

    <router-view />

    <!-- Toast global -->
    <transition name="toast">
      <div
        v-if="toast.visible"
        :class="['fixed bottom-6 right-6 z-50 flex items-center gap-3 px-5 py-4 rounded-2xl shadow-2xl text-white font-semibold text-sm max-w-sm',
                 toast.tipo === 'success' ? 'bg-emerald-500' :
                 toast.tipo === 'error'   ? 'bg-red-500'     :
                 toast.tipo === 'warning' ? 'bg-amber-500'   : 'bg-emerald-500']"
      >
        <i :class="['text-lg',
                    toast.tipo === 'success' ? 'fa-solid fa-circle-check' :
                    toast.tipo === 'error'   ? 'fa-solid fa-circle-xmark' :
                    toast.tipo === 'warning' ? 'fa-solid fa-triangle-exclamation' :
                    'fa-solid fa-circle-info']"></i>
        <span>{{ toast.mensaje }}</span>
        <button @click="cerrarToast" class="ml-2 opacity-80 hover:opacity-100">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
    </transition>

    <!-- Confirm global -->
    <transition name="modal">
      <div v-if="confirmar.visible" class="fixed inset-0 z-[100] flex items-center justify-center p-4" style="background:rgba(15,23,42,.55)">
        <div class="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6">
          <div class="flex items-start gap-4 mb-5">
            <div class="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">
              <i class="fa-solid fa-triangle-exclamation text-amber-500"></i>
            </div>
            <div>
              <p class="font-bold text-slate-800 text-base">{{ confirmar.titulo }}</p>
              <p class="text-slate-500 text-sm mt-1">{{ confirmar.mensaje }}</p>
            </div>
          </div>
          <div class="flex gap-3 justify-end">
            <button @click="responder(false)" class="px-4 py-2 rounded-xl border border-slate-200 text-slate-600 text-sm font-semibold hover:bg-slate-50 transition-colors">
              Cancelar
            </button>
            <button @click="responder(true)" class="px-4 py-2 rounded-xl bg-red-500 hover:bg-red-600 text-white text-sm font-semibold shadow-lg shadow-red-200 transition-all">
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'App',
  data () {
    return {
      nuevaVersion: false,
      htmlBaseline: null,
      versionInterval: null
    }
  },
  computed: {
    ...mapState(['toast', 'confirmar'])
  },
  mounted () {
    this.iniciarVerificacionVersion()
  },
  beforeDestroy () {
    if (this.versionInterval) clearInterval(this.versionInterval)
  },
  methods: {
    ...mapMutations(['CERRAR_TOAST']),
    cerrarToast () {
      this.CERRAR_TOAST()
    },
    responder (valor) {
      this.$store.dispatch('responderConfirm', valor)
    },
    async iniciarVerificacionVersion () {
      try {
        const res = await fetch('/index.html', { cache: 'no-store' })
        this.htmlBaseline = await res.text()
      } catch (e) { /* no bloquear la app */ }
      // Verificar cada 5 minutos
      this.versionInterval = setInterval(this.verificarVersion, 5 * 60 * 1000)
    },
    async verificarVersion () {
      try {
        const res = await fetch('/index.html', { cache: 'no-store' })
        const html = await res.text()
        if (this.htmlBaseline && html !== this.htmlBaseline) {
          this.nuevaVersion = true
          clearInterval(this.versionInterval)
        }
      } catch (e) { /* ignorar errores de red */ }
    },
    actualizarPagina () {
      window.location.reload(true)
    }
  }
}
</script>

<style>
.modal-enter-active, .modal-leave-active { transition: all .2s ease; }
.modal-enter, .modal-leave-to { opacity: 0; transform: scale(.95); }
.toast-enter-active, .toast-leave-active { transition: all .3s ease; }
.toast-enter, .toast-leave-to { opacity: 0; transform: translateY(12px); }
.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to { transform: translateY(-100%); opacity: 0; }
</style>

